(function () {
  'use strict';

  /* global _ */
  class CadastrarUoCtrl {
    constructor($location, $stateParams, Uos, UoParceira, UoArvoreNivel, AlertMessage, Authenticator, SegmentosEnum, Restangular, $uibModal, $translate) {
      this.location = $location;
      this.stateParams = $stateParams;
      this.uoService = Uos;
      this.uoParceiraService = UoParceira;
      this.uoArvoreNivel = UoArvoreNivel;
      this.alertMessage = AlertMessage;
      this.segmentosEnum = SegmentosEnum;
      this.modalService = $uibModal;
      this.uos = [];
      this.uoBloqueioWrapper = {};
      this.uoPai = false;
      this.usuario = {};
      this.uoPaiSetado = this.stateParams.uoPai;
      this.limit = 10;
      this.podeEditarSegmento = false;
      this.isSegmentRequired = true;
      this.uoPaiChanged = false;
      this.EMAIL_REGEX = /^[a-zA-Z0-9\+\.\_\%\-\+]{1,256}\@[a-zA-Z0-9][a-zA-Z0-9\-]{0,64}(\.[a-zA-Z0-9][a-zA-Z0-9\-]{1,25})+$/;
      this.PSVI_SUBDOMAIN_REGEX = /^[a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?$/;
      this.PSVI_DEFAULT_SUBDOMAIN = 'psvi';
      this.restangular = Restangular;
      this.translate = $translate;
      this.allowedEmailList = [
        'trimble.com',
        'platformscience.com',
        'grparceria.com.br',
        'geoagri.com.br'
      ];
      this.segmentosTraduzidos = [];
      this.segmentoSelecionado = null;
      Authenticator.getUser().then(user => {
        this.user = user;
        if (this.user.login) {
          this.allowCreateOu = this.allowedEmailList.includes(this.user.login.split('@')[1]) && Authenticator.hasRole('UO_EDITAR');
        } else {
          this.allowCreateOu = false;
        }
        this.enableNaFeatures = Authenticator.hasRole('ADMIN_VELTEC');
        this.init();
      });
    }
    loadMore() {
      this.limit += 10;
    }

    init() {
      this.traduzirSegmentos();

      if (this.stateParams.uoId > 0) {
        this.uoService.getComDadosDeBloqueio(this.stateParams.uoId).then(uoBloqueioWrapper => {
          this.uoBloqueioWrapper = uoBloqueioWrapper;
          this.segmentoSelecionado = this.segmentosEnum.getSegmentoByKey(uoBloqueioWrapper.uo.segmento);
          if (this.segmentoSelecionado) {
            this.segmentoSelecionado.value = this.translate.instant(this.segmentoSelecionado.value);
          }
          this.orionDeploymentId = uoBloqueioWrapper.uo.orionDeploymentId;
          this.auth0OrgId = uoBloqueioWrapper.uo.auth0OrgId;
          this.podeEditarSegmento = this.allowCreateOu && angular.isUndefined(uoBloqueioWrapper.uo.id_sav);
          this.isSegmentRequired = angular.isUndefined(uoBloqueioWrapper.uo.id_sav);
          this.uoPaiIdInitialValue = this.uoBloqueioWrapper.uo.uoPai.id;
          this.uoBloqueada = angular.isDefined(uoBloqueioWrapper.uoBloqueio);
          this.vehicleRegistration = uoBloqueioWrapper.ouFeatureConfig && uoBloqueioWrapper.ouFeatureConfig.vehicleRegistration;
          this.psviOrionSubdomain = uoBloqueioWrapper.ouFeatureConfig && uoBloqueioWrapper.ouFeatureConfig.psviOrionSubdomain;
          this.storedSubdomain = this.psviOrionSubdomain;
          this.loadParentSubdomain(uoBloqueioWrapper.uo);
          this.mensagemBloqueio = this.uoBloqueada ? uoBloqueioWrapper.uoBloqueio.mensagem : '';
          this.loadUos();
        });
      } else {
        this.podeEditarSegmento = this.allowCreateOu;
        this.loadUos();
      }
    }

    traduzirSegmentos() {
      this.segmentosTraduzidos = this.segmentosEnum.getAllSegmentos().map(segmento => {
        return {
          key: segmento.key,
          value: this.translate.instant(segmento.value)
        };
      });
    }

    loadUos() {
      this.uoService.getFilhas().then(data => {
        this.uos = this.uoArvoreNivel.converterEmListaSemFilhas(data.plain(), this.stateParams.uoId);
        if (this.stateParams.uoId > 0) {
          _.each(this.uos, uo => {
            if (uo.id === this.uoBloqueioWrapper.uo.uoPai.id) {
              this.uoBloqueioWrapper.uo.uoPai = uo;
            }
          }
          );
        }
      });
    }

    salvar() {
      if (this.isCadastro()) {
        let uoCadastro = {
          id: 0,
          nome: this.uoBloqueioWrapper.uo.nome,
          uoPaiId: angular.isDefined(this.uoBloqueioWrapper.uo.uoPai) ? this.uoBloqueioWrapper.uo.uoPai.id : null,
          site: this.uoBloqueioWrapper.uo.site,
          segmento: this.getSegmento(this.segmentoSelecionado),
          customerAccountUuid: this.uoBloqueioWrapper.uo.customerAccountUuid,
          ativo: true
        };
        this.uoService.cadastrar(uoCadastro).then(
          this.showSucces.bind(this),
          this.showError.bind(this));
      } else if (this.uoPaiChanged) {
        /* eslint-disable */
        const dialogAvisoMovimentarUO = document.createElement('pwc-aviso-movimentar-uo'),
          bodyElement = document.querySelector('body');
        bodyElement.appendChild(dialogAvisoMovimentarUO);
        dialogAvisoMovimentarUO.addEventListener('onConfirmacaoMovimentarUO', () => this.atualizarUo());
        /* eslint-enable */
      } else {
        this.atualizarUo();
      }
    }

    atualizarUo() {
      this.uoBloqueioWrapper.uoBloqueio = this.getUoBloqueio();
      this.uoBloqueioWrapper.uo.segmento = this.getSegmento(this.segmentoSelecionado);
      this.uoBloqueioWrapper.uo.ativo = !this.uoBloqueada;
      this.uoBloqueioWrapper.uo.orionDeploymentId = this.orionDeploymentId;
      this.uoBloqueioWrapper.uo.auth0OrgId = this.auth0OrgId;
      this.uoBloqueioWrapper.ouFeatureConfig = this.getOuFeatureConfig();
      this.uoBloqueioWrapper.put().then(this.showSucces.bind(this), this.showError.bind(this));
    }

    getSegmento(segmento) {
      return segmento ? segmento.key : 'NAO_MAPEADO';
    }

    getOuFeatureConfig() {
      return {
        ouId: this.uoBloqueioWrapper.uo.id,
        vehicleRegistration: this.vehicleRegistration,
        vehicleTable: this.vehicleRegistration,
        decoratedVideoPlayer: this.vehicleRegistration,
        deviceScreen: this.vehicleRegistration,
        alertSettings: this.vehicleRegistration,
        events: this.vehicleRegistration,
        trimbleLogo: this.vehicleRegistration,
        lastVisitedPageReload: this.vehicleRegistration,
        vi20ProductName: this.vehicleRegistration,
        psviOrionSubdomain: this.buildPsviOrionSubdomain()
      };
    }

    buildPsviOrionSubdomain() {
      if (!this.vehicleRegistration) {
        return null;
      }
      if (this.subdomainFromParent) {
        return this.psviOrionSubdomain || null;
      }
      if (this.orionDeploymentId && this.psviOrionSubdomain) {
        return this.psviOrionSubdomain;
      }
      return this.PSVI_DEFAULT_SUBDOMAIN;
    }

    onOrionDeploymentIdChange() {
      if (this.subdomainFromParent) {
        return;
      }
      this.hideSubdomainField = !this.orionDeploymentId;
    }

    loadParentSubdomain(uo) {
      const parentId = uo.uoPai && uo.uoPai.id, childSubdomain = this.storedSubdomain;
      if (!parentId || parentId === 1) {
        this.subdomainFromParent = false;
        this.subdomainAlreadyApplied = false;
        this.hideSubdomainField = !this.orionDeploymentId;
        if (this.orionDeploymentId && !this.psviOrionSubdomain) {
          this.psviOrionSubdomain = this.PSVI_DEFAULT_SUBDOMAIN;
        }
        return;
      }
      this.subdomainFromParent = true;
      this.hideSubdomainField = true;
      this.subdomainAlreadyApplied = false;
      this.resolveRootSubdomain(parentId, childSubdomain);
    }

    resolveRootSubdomain(ancestorId, childSubdomain) {
      this.uoService.getComDadosDeBloqueio(ancestorId).then(wrapper => {
        const grandParentId = wrapper.uo && wrapper.uo.uoPai && wrapper.uo.uoPai.id;
        if (grandParentId && grandParentId !== 1 && grandParentId !== ancestorId) {
          this.resolveRootSubdomain(grandParentId, childSubdomain);
          return;
        }
        this.applyRootSubdomain(wrapper, childSubdomain);
      });
    }

    applyRootSubdomain(rootWrapper, childSubdomain) {
      const rootSubdomain = rootWrapper.ouFeatureConfig && rootWrapper.ouFeatureConfig.psviOrionSubdomain,
          rootOrionDeploymentId = rootWrapper.uo && rootWrapper.uo.orionDeploymentId,
          childHasCustom = childSubdomain && childSubdomain !== this.PSVI_DEFAULT_SUBDOMAIN;
      if (rootSubdomain && rootSubdomain !== this.PSVI_DEFAULT_SUBDOMAIN) {
        this.psviOrionSubdomain = rootSubdomain;
        this.hideSubdomainField = false;
        this.subdomainAlreadyApplied = rootSubdomain === childSubdomain;
      } else if (rootOrionDeploymentId) {
        this.psviOrionSubdomain = this.PSVI_DEFAULT_SUBDOMAIN;
        this.hideSubdomainField = false;
        this.subdomainAlreadyApplied = !childHasCustom;
      } else {
        this.psviOrionSubdomain = null;
        this.hideSubdomainField = true;
      }
    }

    onUoPaiChange() {
      this.uoPaiChanged = this.uoBloqueioWrapper.uo.uoPai.id !== this.uoPaiIdInitialValue;
    }

    getUoBloqueio() {
      if (this.uoBloqueada) {
        return {
          id: this.uoBloqueioWrapper.uoBloqueio && this.uoBloqueioWrapper.uoBloqueio.id ?
            this.uoBloqueioWrapper.uoBloqueio.id : 0,
          uoId: this.uoBloqueioWrapper.uo.id,
          usuarioId: this.user.id,
          mensagem: this.mensagemBloqueio
        };
      }
      return null;
    }

    isCadastro() {
      return angular.isUndefined(this.uoBloqueioWrapper.uo.id);
    }

    showSucces(data) {
      this.location.path('/uos');
      this.alertMessage.create({type: 'success', message: data.message, appendTo: '.alerta-aqui'});
    }

    showError(error) {
      if (this.isPsviSubdomainError(error)) {
        this.alertMessage.create({
          type: 'error',
          message: this.translate.instant('core-permissoes.organizacao.uos.orion.psviOrionSubdomainUnreachable'),
          appendTo: '.alerta-aqui'
        });
        return;
      }
      if (error.data.length > 0) {
        let erros = error.data.map(e => e.message);
        erros.forEach(e => this.alertMessage.create({type: 'error', message: e, appendTo: '.alerta-aqui'}));
      } else if (error.data.message && angular.isUndefined(error.data.exception)) {
        this.alertMessage.create({type: 'error', message: error.data.message, appendTo: '.alerta-aqui'});
      } else {
        this.alertMessage.create({type: 'error', message: 'Erro ao salvar Unidade Organizacional, tente novamente.', appendTo: '.alerta-aqui'});
      }
    }

    isPsviSubdomainError(error) {
      const data = error && error.data,
          raw = angular.isString(data) ? data : angular.toJson(data || '');
      return raw.indexOf('psviOrionSubdomain') !== -1;
    }

    importarMotoristas() {
      let accountId = this.uoBloqueioWrapper.uo.customerAccountUuid;
      if (accountId) {
        this.restangular.one('/motorista/ttc/hydrate?accountId=' + accountId).post()
        .then(() => this.alertMessage.create({type: 'success', message: 'Successfully imported drivers', appendTo: '.alerta-aqui'}))
        .catch(() => this.alertMessage.create({type: 'error', message: 'Error when importing drivers', appendTo: '.alerta-aqui'}));
      }
    }

    importarVeiculos() {
      let uoId = this.uoBloqueioWrapper.uo.id;
      if (this.uoBloqueioWrapper.uo.customerAccountUuid) {
        this.restangular.one('/veiculo/v2/veiculos/sync-ttc-vehicle-to-v3g?uoId=' + uoId).post()
        .then(() => this.alertMessage.create({type: 'success', message: 'Successfully imported vehicles', appendTo: '.alerta-aqui'}))
        .catch(() => this.alertMessage.create({type: 'error', message: 'Error when importing vehicles', appendTo: '.alerta-aqui'}));
      }
    }

    importarUsuarios() {
      let accountId = this.uoBloqueioWrapper.uo.customerAccountUuid;
      if (this.uoBloqueioWrapper.uo.customerAccountUuid) {
        this.restangular.one('/auth/ttc/hydrate?accountId=' + accountId).post()
        .then(() => this.alertMessage.create({type: 'success', message: 'Successfully imported users', appendTo: '.alerta-aqui'}))
        .catch(() => this.alertMessage.create({type: 'error', message: 'Error when importing users', appendTo: '.alerta-aqui'}));
      }
    }

    ok(tipoEvento) {
      this.modalService.open({
        templateUrl: 'uos/confirm-import-modal/confirm-import-ttc-modal.tpl.html',
        controller: 'ConfirmImportTtcModalCtrl',
        controllerAs: 'ctrl',
        size: 'md'
      }).result
        .then(() => {
          if (tipoEvento === 'motorista') {
            this.importarMotoristas();
          } else if (tipoEvento === 'usuarios') {
            this.importarUsuarios();
          }else {
            this.importarVeiculos();
          }
        });
    }
  }

  /**
   * @ngdoc object
   * @name uos.controller:CadastrarUoCtrl
   *
   * @description
   *
   */
  angular
    .module('uos')
    .controller('CadastrarUoCtrl', CadastrarUoCtrl);
}());
